import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_FAQ } from "@/data/faq/locale-copy";
import { buildLocaleFaqHead } from "@/lib/faq/locale-head";
import { LocaleFaqPage } from "@/components/faq/LocaleFaqPage";

export const Route = createFileRoute("/ja/faq")({
  loader: () => ({ h: buildLocaleFaqHead("ja", LOCALE_FAQ.ja) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <LocaleFaqPage copy={LOCALE_FAQ.ja} />,
});
